"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireWildcard(require("react-dom"));

var _easingFunctions = require("./subModules/easingFunctions");

var _animationHandlers = require("./subModules/animationHandlers");

var _singularComponentStore = require("./subModules/singularComponentStore");

var _createSnapshot = require("./utils/createSnapshot");

var _createAnimationElement = require("./utils/createAnimationElement");

var _calculateAnimationHandlers = require("./utils/calculateAnimationHandlers");

var _animateSingularComponentElement = require("./utils/animateSingularComponentElement");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_CUSTOM_ANIMATION_HANDLERS = ['width', 'height', 'fontSize'];

var SingularComponent = /*#__PURE__*/function (_Component) {
  _inherits(SingularComponent, _Component);

  var _super = _createSuper(SingularComponent);

  function SingularComponent() {
    var _this;

    _classCallCheck(this, SingularComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "takeSnapshot", function () {
      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.element;
      var _this$props = _this.props,
          extraSnapshotStyleAttributes = _this$props.extraSnapshotStyleAttributes,
          customAnimationHandlers = _this$props.customAnimationHandlers;

      var styleAttrsToCopy = _toConsumableArray(extraSnapshotStyleAttributes); // When Using styleAnimation (which uses the default customAnimationHandler) or customAnimationHandlers,
      // We want to automatically add the style handlers mentioned by their name to the snapshot.
      // for example if the 'width' handler is used than the width attribute will automatically be added.


      if (_this.shouldUseCustomAnimationHandlers) {
        styleAttrsToCopy.push.apply(styleAttrsToCopy, _toConsumableArray(customAnimationHandlers.filter(function (handler) {
          return typeof handler === 'string';
        })));
      }

      return (0, _createSnapshot.createSnapshot)(element, styleAttrsToCopy);
    });

    _defineProperty(_assertThisInitialized(_this), "setStoreSnapshot", function () {
      if (_this.element) {
        _this.store.lastSnapshot = _this.takeSnapshot();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "createAnimationElement", function () {
      var customTransitionElement = _this.props.customTransitionElement;
      var animationFromElement = _this.element;

      if (customTransitionElement) {
        var div = document.createElement("div");

        _reactDom["default"].render(_this.props.customTransitionElement, div);

        if (div.childNodes.length > 0) {
          animationFromElement = div.childNodes[0];
        }
      }

      return (0, _createAnimationElement.createAnimationElement)(animationFromElement);
    });

    _defineProperty(_assertThisInitialized(_this), "animateComponent", function () {
      var _this$props2 = _this.props,
          animationDuration = _this$props2.animationDuration,
          easing = _this$props2.easing,
          onAnimationBegin = _this$props2.onAnimationBegin,
          onAnimationComplete = _this$props2.onAnimationComplete,
          continuousAnimation = _this$props2.continuousAnimation;
      var _this$store = _this.store,
          lastAnimation = _this$store.lastAnimation,
          lastSnapshot = _this$store.lastSnapshot;
      var startSnapshot = lastSnapshot;

      if (lastAnimation.ongoing) {
        if (continuousAnimation) startSnapshot = lastAnimation.snapshotTrack;
        lastAnimation.cancel();
      }

      if (startSnapshot) {
        var animationElement = _this.createAnimationElement();

        _this.element.style.visibility = 'hidden';

        var cleanUp = function cleanUp() {
          animationElement.remove();
          if (_this.element) _this.element.style.visibility = '';
        };

        onAnimationBegin(_this.element, animationElement);
        _this.store.lastAnimation = (0, _animateSingularComponentElement.animateSingularComponentElement)(animationElement, _this.takeSnapshot, startSnapshot, _this.animationHandlers, _easingFunctions.EasingFunctions[easing], animationDuration, {
          onFinishRead: _this.setStoreSnapshot,
          onFinishWrite: function onFinishWrite() {
            cleanUp();
            onAnimationComplete(_this.element);
          },
          onCancel: cleanUp
        });
      }
    });

    return _this;
  }

  _createClass(SingularComponent, [{
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(nextProps) {
      if (this.props.animationTrigger !== nextProps.animationTrigger) {
        this.setStoreSnapshot();
      }

      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var element = (0, _reactDom.findDOMNode)(this);

      if (this.element !== element) {
        this.element = element;
        if (this.element) this.animateComponent();
      } else if (this.element && this.props.animationTrigger !== prevProps.animationTrigger) {
        this.animateComponent();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.store.register(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setStoreSnapshot();
      this.store.unregister(this);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return this.shouldShow ? _react.Children.only(children) : null;
    }
  }, {
    key: "store",
    get: function get() {
      var singularKey = this.props.singularKey;
      return new _singularComponentStore.SingularComponentStore(singularKey);
    }
  }, {
    key: "shouldUseCustomAnimationHandlers",
    get: function get() {
      var _this$props3 = this.props,
          useStyleAnimation = _this$props3.useStyleAnimation,
          customAnimationHandlers = _this$props3.customAnimationHandlers;
      return useStyleAnimation || customAnimationHandlers !== DEFAULT_CUSTOM_ANIMATION_HANDLERS;
    }
  }, {
    key: "animationHandlers",
    get: function get() {
      var customAnimationHandlers = this.props.customAnimationHandlers;
      return (0, _calculateAnimationHandlers.calculateAnimationHandlers)(this.shouldUseCustomAnimationHandlers, customAnimationHandlers);
    }
  }, {
    key: "shouldShow",
    get: function get() {
      return Math.max.apply(Math, _toConsumableArray(this.store.priorities)) === this.props.singularPriority;
    }
  }]);

  return SingularComponent;
}(_react.Component);

SingularComponent.propTypes = {
  singularKey: _propTypes["default"].string.isRequired,
  singularPriority: _propTypes["default"].number.isRequired,
  animationDuration: _propTypes["default"].number,
  animationTrigger: _propTypes["default"].any,
  onAnimationBegin: _propTypes["default"].func,
  onAnimationComplete: _propTypes["default"].func,
  customTransitionElement: _propTypes["default"].node,
  easing: _propTypes["default"].oneOf(Object.keys(_easingFunctions.EasingFunctions)),
  useStyleAnimation: _propTypes["default"].bool,
  customAnimationHandlers: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].oneOf(Object.keys(_animationHandlers.StyleHandlers))])),
  extraSnapshotStyleAttributes: _propTypes["default"].arrayOf(_propTypes["default"].string),
  continuousAnimation: _propTypes["default"].bool
};
SingularComponent.defaultProps = {
  animationDuration: 500,
  animationTrigger: 0,
  onAnimationBegin: function onAnimationBegin() {},
  onAnimationComplete: function onAnimationComplete() {},
  easing: 'easeOutQuad',
  useStyleAnimation: false,
  customAnimationHandlers: DEFAULT_CUSTOM_ANIMATION_HANDLERS,
  extraSnapshotStyleAttributes: [],
  continuousAnimation: true
};
var _default = SingularComponent;
exports["default"] = _default;